export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00052.cfe189db.png";